// Applies i18n strings to static DOM chrome (drawers, a11y mirror, loading).
import { formatMoneyLocale, type I18n } from '@aerofruits/i18n';

function setText(id: string, text: string): void {
  const el = document.getElementById(id);
  if (el) el.textContent = text;
}

function setHtml(id: string, html: string): void {
  const el = document.getElementById(id);
  if (el) el.innerHTML = html;
}

/** Updates every static, non-VM-driven DOM label after a locale change. */
export function applyStaticDom(i18n: I18n): void {
  const t = i18n.t.bind(i18n);
  setText('a11y-demo-note', t('dice.demo.note'));
  setText('roll', t('dice.actions.roll'));
  setText('bet-down', t('dice.actions.decreaseBet'));
  setText('bet-up', t('dice.actions.increaseBet'));
  setText('max-bet', t('dice.actions.max'));
  setText('btn-history', t('dice.toolbar.history'));
  setText('btn-rules', t('dice.toolbar.rules'));
  setText('history-title', t('dice.history.title'));
  setText('history-close', t('common.actions.close'));
  setText('rules-title', t('lightning.rules.title'));
  setText('rules-close', t('common.actions.close'));
  setText('open-language', t('dice.rules.languageLink'));
  setText('replay-close', t('dice.actions.exitReplay'));
  setText('replay-badge-label', t('dice.status.replay'));
  setText('expired-title', t('dice.errors.sessionExpired'));
  setText('expired-text', t('dice.errors.sessionExpired'));
  setText('loading-logo', t('lightning.game.title').toUpperCase());

  setHtml('rules-body-list', [
    t('lightning.rules.bullet1'),
    t('lightning.rules.bullet2'),
    t('lightning.rules.bullet3'),
    t('lightning.rules.bullet4'),
    t('lightning.rules.bullet5'),
    t('lightning.rules.bullet6'),
    t('lightning.rules.bullet7'),
  ].map((line) => `<li>${line}</li>`).join(''));
  setText('rules-note', t('lightning.rules.note'));
  setText('rules-disclaimer', t('lightning.rules.disclaimer'));

  const thRound = document.getElementById('th-round');
  if (thRound) thRound.textContent = t('dice.history.round');
  const thWhen = document.getElementById('th-when');
  if (thWhen) thWhen.textContent = t('dice.history.when');
  const thPick = document.getElementById('th-pick');
  if (thPick) thPick.textContent = t('dice.history.pick');
  const thDice = document.getElementById('th-dice');
  if (thDice) thDice.textContent = t('dice.history.dice');
  const thBet = document.getElementById('th-bet');
  if (thBet) thBet.textContent = t('dice.stats.bet');
  const thWin = document.getElementById('th-win');
  if (thWin) thWin.textContent = t('dice.history.win');

  document.getElementById('roll')?.setAttribute('aria-label', t('dice.a11y.rollDice'));
  document.getElementById('history-close')?.setAttribute('aria-label', t('dice.a11y.closeHistory'));
  document.getElementById('rules-close')?.setAttribute('aria-label', t('dice.a11y.closeRules'));
  document.getElementById('replay-close')?.setAttribute('aria-label', t('dice.a11y.exitReplay'));
  document.getElementById('open-language')?.setAttribute('aria-label', t('dice.a11y.language'));
}

/** Updates sound toggle labels to reflect muted/enabled state. */
export function applySoundDom(muted: boolean, i18n: I18n): void {
  const t = i18n.t.bind(i18n);
  const label = muted ? t('dice.sound.disabled') : t('dice.sound.enabled');
  setText('btn-sound', label);
  const btn = document.getElementById('btn-sound');
  btn?.setAttribute('aria-pressed', String(muted));
  btn?.setAttribute('aria-label', muted ? t('dice.sound.muted') : t('dice.sound.enabled'));
  document.getElementById('roll')?.setAttribute('aria-label', t('dice.a11y.rollDice'));
}

export function formatMoneyForLocale(i18n: I18n, minor: number, currency: string): string {
  return formatMoneyLocale(minor, currency, i18n.getLocale());
}
